import React, { useState, useEffect } from 'react';
import { authService } from '../utils/api';

interface Props {
  children: any;
}

// Simple error handler for authentication errors
const AuthErrorBoundary: React.FC<Props> = ({ children }) => {
  const [hasAuthError, setHasAuthError] = useState(false);

  useEffect(() => {
    // Listen for unhandled promise rejections that might be auth errors
    const handleUnhandledRejection = async (event: PromiseRejectionEvent) => {
      const error = event.reason;
      if (error && error.message && 
          (error.message.includes('Session expired') || 
           error.message.includes('unauthorized') ||
           error.message.includes('401'))) {
        console.error('Authentication error caught:', error);
        setHasAuthError(true);
        await authService.logout();
        // Prevent the error from being logged to console
        event.preventDefault();
      }
    };

    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    
    return () => {
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  if (hasAuthError) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="max-w-md w-full p-8 rounded-lg shadow-md bg-white text-center">
          <svg className="w-16 h-16 mx-auto text-red-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
          <h2 className="text-2xl font-bold mb-4 text-gray-900">Authentication Error</h2>
          <p className="text-gray-600 mb-6">Your session has expired. You will be redirected to the login page.</p>
          <button 
            onClick={() => window.location.href = '/login'} 
            className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors"
          >
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default AuthErrorBoundary; 